import React from 'react';
import {  Row, Col } from 'antd';
import './copyright.css'

function Copyright() {
   
        return (
            <div>
                 <Row justify="center"  >
                        <Col className="copyright" xs={24} sm={24} md={24} lg={24} xl={24}>
                            <div className="copyright-inner">
                            <h1 className="copyright-left-txt">&copy; Copyrights 2020 4IR Skills All rights reserved.</h1>
                            <h2 className="copyright-right-txt">Designed by Faiza Ninja's</h2>
                            </div>
                        </Col>
                 </Row>                   
            </div>
        )
    }


export default Copyright;
